// extracted by mini-css-extract-plugin
export default {"image":"m0-z","loaded":"n0-z"};